import SectionHeading from "./SectionHeading";
import { categoryList } from "@/mocks/doujinData";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50",
  secondary: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50",
};

export default function Categories() {
  return (
    <section id="category" className="py-16 md:py-24 bg-background-100">
      <div className="container-x">
        <SectionHeading
          eyebrow="作品分类"
          title="细致分类，快速找到心仪作品"
          desc="按画集、图包、高清原图与扫描本集分类整理，题材覆盖广，方便收藏与参考。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categoryList.map((cat) => (
            <a
              key={cat.id}
              href="#gallery"
              className="group rounded-xl bg-background-50 border border-background-200 p-6 md:p-7 hover:-translate-y-1 transition-transform duration-300"
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl transition-colors ${colorMap[cat.color]}`}
              >
                <i className={cat.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{cat.title}</h3>
              <p className="mt-1.5 text-sm text-foreground-600">{cat.desc}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                  <i className="ri-folder-2-line"></i>
                  {cat.count.toLocaleString()} 部
                </span>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                  去看看 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}